import Icon from '../utilities/Icon'

interface FilterBarProps {
  toggleFilter: () => void
  toggleSort: () => void
  activeFilters: number
  activeSort: string
}

export const FilterBar = ({
  toggleFilter,
  toggleSort,
  activeFilters = 0,
  activeSort = '',
}: FilterBarProps) => {
  const sorts = new Map([
    ['relevant', 'Sort By'],
    ['new-product', 'New Product'],
    ['most-selling', 'Most Popular'],
    ['lowest-price', 'Lowest Price'],
    ['highest-price', 'Highest Price'],
  ])

  return (
    <div className='bg-white mx-4 mt-2 rounded-lg border-[0.5px] border-gray'>
      <div className='flex font-medium text-sm h-[55px] px-2'>
        <div className='flex gap-2 flex-grow items-center cursor-pointer' onClick={toggleFilter}>
          {activeFilters > 0 ? (
            <div className='flex bg-green w-[23px] h-[23px] justify-center rounded-lg align-center text-white'>
              {activeFilters}
            </div>
          ) : (
            <Icon iconSrc={'/icons/ic-filter.svg'} alt='filter' lazyLoad={false} />
          )}
          Filter
        </div>
        <div className='flex gap-6'>
          <div
            className='flex flex-grow justify-center items-center gap-2 capitalize cursor-pointer'
            onClick={toggleSort}
          >
            <Icon iconSrc={'/icons/ic-sort.svg'} alt='sort' lazyLoad={false} />
            {activeSort ? sorts.get(activeSort) : 'sort by'}
          </div>
        </div>
      </div>
    </div>
  )
}
